<template>
  <input
    type="date"
    v-model="internalDay"
    @change="$emit('emittedDay', internalDay)"
    max="9999-12-31"
    pattern="\d{4}-\d{2}-\d{2}"
    class="input-layout w3-border w3-round-medium"
  />
</template>

<script>
export default {
  name: "DatePicker",
  components: {},
  props: ["day"],
  emits: ["emittedDay"],
  data() {
    return {
      internalDay: this.day,
    };
  },
  watch: {
    day(newValue) {
      this.internalDay = newValue;
    },
  },
};
</script>

<style scoped>
.input-layout {
  aspect-ratio: 5;
  padding: 8px;
  display: block;
  border: none;
  border-bottom: 1px solid #ccc;
  width: 100%;
  max-width: 200px;
  margin-right: 1%;
}
</style>
